// Controls the inline boot loader painted by the mobile-web HTML shell
// (src/mobile-web/public/index.html, element #zkx-loader). The loader is plain
// DOM rendered before the JS bundle/React mount, so we tear it down imperatively
// once the first real screen has actually painted.
//
// Safe to call multiple times and on native (no-op when there is no DOM).
const FADE_OUT_MS = 450

export const dismissBootLoader = () => {
  if (typeof document === 'undefined') return

  const loader = document.getElementById('zkx-loader')
  if (!loader || loader.classList.contains('is-hidden')) return

  // done() runs async (it enforces a min on-screen time + tweens the bar to 100%
  // before invoking this callback), so guard against the multiple dismiss calls
  // that would otherwise queue several fade-outs.
  if (loader.getAttribute('data-dismissing') === '1') return
  loader.setAttribute('data-dismissing', '1')

  const fadeOut = () => {
    loader.classList.add('is-hidden')
    setTimeout(() => loader.remove(), FADE_OUT_MS)
  }

  // Fill the progress bar to 100%, then fade out once it has visibly completed.
  const boot = (window as any).__zkxBoot
  if (boot?.done) boot.done(fadeOut)
  else fadeOut()
}
